<template>
	<el-dialog :title="'封闭情况'" :close-on-click-modal="false" :visible.sync="visible" width="940px" ref="dialog">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="85px" class="border-form">

			<el-row class="set_border">
				<el-col :span="14" class="col-set_border">
					<el-form-item label="封闭时间" class="item">
						<!-- <el-date-picker v-model="dataForm.closeTime" type="date" value-format="yyyy-MM-dd"
							:clearable="false" class="no-border-input"> -->
						<el-date-picker class="no-border-input" v-model="dataForm.closeTime" type="date"
							value-format="yyyy-MM-dd" placeholder="选择时间">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="10" class="col-set_border">
					<el-form-item label="封闭人" class="item">
						<el-input v-model="dataForm.closeMan" class="no-border-input"></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="24" class="row-form-item">
					<el-form-item label="封闭时描述（如有时）" class="fileItem">
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-input type="textarea" :rows="4" v-model="dataForm.closeDescribe"
						class="set_data no-border-input">
					</el-input>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="row-form-item">
					<el-form-item label="封闭时附件（如有时）" class="fileItem">
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-upload ref="uploadScanFile" class="upload-demo" action="action" drag
						:http-request="uploadScanFile" multiple :show-file-list=false :auto-upload="true">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>
				</el-col>
				<el-col :span="16">
					<el-table :data="dataForm.fileList" :cell-style="{ padding: '0px' }" style="margin-bottom: 20px;"
						v-if="dataForm.fileList && dataForm.fileList.length > 0">
						<el-table-column type="index" label="No." width="50px">
						</el-table-column>
						<el-table-column prop="fileName" label="文件名" align="center" width="415px">
							<template slot-scope="scope">
								<el-input v-model="dataForm.fileList[scope.$index].fileName" placeholder="请填写"
									class="file_input"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="120" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="text" @click="viewFile(scope.$index)">查看</el-button>
								<el-button size="mini" type="text" @click="delFile(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
			<el-button v-preventReClick class="rebtn" size="small" @click="visible = false">取消</el-button>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import { initDialogDrag } from '@/utils/dialogDrag.js'
export default {
	name: "superdocument-audit",
	data() {
		return {
			editorConfig: {
				UEDITOR_HOME_URL: "/UEditor/"
			},
			fileList: [],
			action: '',
			visible: false,
			inline: false,
			documentTypeList: [],
			type: '',
			dataForm: {
				fileId: '',
				closeFlg: '',
				closeMan: '',
				closeTime: '',
				closeDescribe: '',
				fileList: [],
				subjectName: '',
				receiveMan: '',
				receiveDate: '',
				receiveComments: ''
			},
			dataRule: {
				closeMan: [
					{ required: true, message: "请输入封闭人", trigger: "blur" }
				],
				closeTime: [
					{ required: true, message: "请选择封闭时间", trigger: "blur" }
				]
			},
		}
	},
	methods: {
		init(id) {
			this.dataForm = {
				fileId: '',
				closeFlg: '',
				closeMan: '',
				closeTime: '',
				closeDescribe: '',
				fileList: [],
				receiveMan: '',
				receiveDate: '',
				receiveComments: ''
			};
			this.fileList = []
			this.dataForm.fileId = id ? id : 0;
			this.$nextTick(() => {
				this.visible = true;
				initDialogDrag(this.$refs.dialog.$el);
				if (this.dataForm.fileId) {
					this.getDetail();
				}
				// this.$refs['dataForm'].resetFields();
			});
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		handleRemove(file, fileList) {
		},
		uploadScanFile(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadScanFile.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/20/01",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					let item = {
						fileId: this.dataForm.fileId,
						fileName: this.extractFileName(res.body.fileName),
						filePathUrl: res.body.fileUri,
						filePath: res.body.fileSavePath
					}
					this.dataForm.fileList.push(item)
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		getDetail() {
			console.log("this.dataForm.fileId", this.dataForm.fileId)
			this.$http({
				url: this.$store.state.httpUrl + `/business/noticeinfo/info/${this.dataForm.fileId}`,
				method: "get",
				params: {}
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = {
						fileId: data.body.fileId,
						fileNo: data.body.fileNo,
						fileTitle: data.body.fileTitle,
						fileContent: data.body.fileContent,
						handleOptions: data.body.handleOptions,
						subjectName: data.body.subjectName,
						receiveMan: data.body.receiveMan,
						receiveDate: data.body.receiveDate,
						closeFlg: '1',
						closeMan: data.body.closeMan,
						closeTime: data.body.closeTime,
						closeDescribe: data.body.closeDescribe,
						receiveComments: data.body.receiveComments,
						fileList: data.body.fileList
					};
					this.fileList = this.dataForm.fileList
				}
			});
		},
		viewFile(index) {
			window.open(this.fileList[index].filePathUrl);
		},
		delFile(index) {
			this.fileList.splice(index, 1)
		},
		//表单提交
		dataFormSubmit() {
			console.log(this.dataForm.closeTime)
			if (this.dataForm.closeTime == '' || this.dataForm.closeTime == undefined) {
				this.$message.error("请填写封闭时间！")
				return;
			}
			if (this.dataForm.closeMan == '' || this.dataForm.closeMan == undefined) {
				this.$message.error("请填写封闭人！")
				return;
			}
			this.dataForm.fileList = this.fileList
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/noticeinfo/closedUpdateButtonNoticeInfoProcessing";
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									this.$parent.getDataList();
								}
							});
						}
					});
				}
			});
		}
	}
}
</script>
<style scoped lang="scss">
.selItemInput.descAreaLg {
	width: 640px !important;
}

.con-le {
	margin-top: 10px;

}

::v-deep .el-upload-dragger {
	width: 260px !important;
	height: 185px !important;
	margin-top: 10px !important;
	margin-bottom: 10px !important;
}

::v-deep .el-icon-upload {
	font-size: 40px !important;
	margin: 0 0 !important;
	line-height: 40px !important;
	padding-top: 45px !important;
}

::v-deep .el-upload__tex t {
	line-height: 20px !important;
}

.fileItem::v-deep .el-form-item__label {
	text-align: right;
	color: #00428e !important;
	font-weight: bold !important;
	width: 100% !important;
	height: 15px !important;
	display: flex;
	align-items: center;
}

.item::v-deep .el-form-item__label {
	color: #00428e !important;
	margin-right: 0px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	height: 40px !important;
	border-top: 1px solid #dadada;
	border-left: 1px solid #dadada;
	border-bottom: 1px solid #dadada;
}

.col-set_border .el-form-item {
	margin-right: 0px;
	margin-bottom: 0px;
}

.set_data {
	margin-top: 1px;
}

.fileItem {
	margin-bottom: 0px !important;
	border: 1px solid #dadada;
}

/* 移除表头特殊的加粗边框 */
::v-deep .el-table__header-wrapper th {
	border: none !important
}

::v-deep .el-table__header-wrapper th,
::v-deep .el-table__body-wrapper td {
	border-top: 1px solid #dadada !important;
	border-right: 1px solid #dadada !important;
	border-bottom: 1px solid #dadada !important;
	border-left: 1px solid #dadada !important;
}

::v-deep .el-table__header-wrapper th:first-child,
::v-deep .el-table__body-wrapper td:first-child {
	border-left: 1px solid #dadada !important;
}

.no-border-input.el-date-editor.el-date-editor--date {
	::v-deep .el-input__suffix {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		position: absolute !important;
		/* 必须加！否则right无效且图标易消失 */
		top: 50% !important;
		/* 垂直居中，避免图标偏移 */
		transform: translateY(-50%) !important;
		right: 5px !important;
		/* 你要的右侧5px间距 */
		width: auto !important;
		/* 取消固定宽度，避免容器遮挡 */
		height: 100% !important;
		/* 占满高度，确保点击生效 */
		pointer-events: auto !important;
		/* 保证图标可点击，避免失效 */
		z-index: 1 !important;
		/* 防止图标被遮挡 */
	}

	/* 隐藏左侧占位，不影响右侧图标 */
	::v-deep .el-input__prefix {
		display: none !important;
		width: 0 !important;
		padding: 0 !important;
		margin: 0 !important;
	}

	/* 补充：给输入框右侧留空间，避免文字遮挡图标 */
	::v-deep .el-input__inner {
		padding-right: 30px !important;
		/* 适配5px右侧间距，留出图标空间 */
		padding-left: 15px !important;
		/* 重置左侧内边距，消除空白 */
		border-radius: 0 !important;
		border: 1px solid #dadada !important;
	}
}

/* 修改输入框为圆角*/
::v-deep .el-input__inner {
	border-radius: 0 !important;
}

/* 焦点状态 - 仅改Element原生主题色，不加粗、无阴影、无任何额外样式 */
::v-deep .el-input__inner:focus {
	border: 1px solid #dadada !important;
}

/* 表格中输入框样式 - 保持宽度100%，只调整高度 */
::v-deep .el-table .el-input {
	height: 36px !important;
	width: 100% !important;
}

::v-deep .el-table .el-input__inner {
	height: 32px !important;
	line-height: 32px !important;
	padding: 0 8px !important;
	margin: 2px 0 !important;
	width: 100% !important;
	box-sizing: border-box !important;
}

/* 针对file_input类的输入框样式 */
.file_input ::v-deep .el-input {
	height: 36px !important;
	width: 100% !important;
}

.file_input ::v-deep .el-input__inner {
	height: 32px !important;
	line-height: 32px !important;
	padding: 0 8px !important;
	width: 100% !important;
	box-sizing: border-box !important;
}

/* 表格单元格内输入框样式，确保输入框高度小于表格行高度 */
::v-deep .el-table .file_input .el-input__inner {
	height: 32px !important;
	line-height: 32px !important;
	padding: 0 5px !important;
}
</style>
